<section class="balanceTable w-full max-w-3xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">מתפללים</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <ng-container *ngIf="data | async as users; else loadingState">
    <div *ngIf="users.length > 0; else empty" class="overflow-x-auto">
      <table class="table-2026 w-full">
        <thead>
          <tr>
            <th>שם מלא</th>
            <th class="text-end">יתרה</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td class="font-semibold">{{ user.firstName }} {{ user.lastName }}</td>
            <td class="text-end money font-semibold"
                [class.money--credit]="user.balance > 0"
                [class.money--debt]="user.balance < 0"
                [class.money--zero]="user.balance === 0">
              {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #empty>
      <div class="card-2026 text-center py-12">
        <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">account_balance_wallet</i>
        <h2 class="text-xl font-semibold text-ink-700">אין נתונים להצגה</h2>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loadingState>
    <div class="card-2026 space-y-3">
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
    </div>
  </ng-template>
</section>
